import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { 
                    data
                } = await axios.get(`procure/detail/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailap(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { 
                    data
                } = await axios.get(`procure/detailap/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status','outstand'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/procure/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'procure_order_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });

    },
    insert(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("procure", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    invoiceTermin(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`procure/invoicetermin`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'vendor', 'vendor_id', 'requestno', 'postgroup', 'item', 'status','outstand'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listinvtermin(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/invoicetermin/${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    hargapo(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['itemno','itemnname','partnumbber', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/hargapo${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    hargapoexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['itemno','itemnname','partnumbber', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/procure/hargapoexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `PO_List_Price${obj.tgl1}_sd_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    hargaquotation(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['itemno','itemnname','partnumbber', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/hargaquotation${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    hargaquotationexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['itemno','itemnname','partnumbber', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/procure/hargaquotationexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Quotation_Price${obj.tgl1}_sd_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },      pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymterms() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/paymterms");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    poinvpaym(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procurereport/poinvpaym${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    poinvpaymexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/procurereport/poinvpaymexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_trx_vendor_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    poinvpaymprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procurereport/poinvpaymprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    invterminprint (obj = {}){
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?pohdrkey=' + encodeURIComponent(obj.pohdrkey);
                url = `/procure/invterminprint`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    invterminexportxls(obj = {}) {
        const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/procure/invterminexportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'receive_invoice_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });

    },
    postgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    // posting(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             await axios.put(`procure/posting/${obj.pohdrkey}`);
    //             resolve();
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
    // postingUndo(obj) {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             await axios.put(`procure/unposting/${obj.pohdrkey}`);
    //             resolve();
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     });
    // },
        approval(formData) {
            return new Promise(async (resolve, reject) => {
                try {
                    console.log('File Name : ', formData.filename);
                    const { data } = await axios.post("procure/send2wf", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    resolve(data);
                } catch (error) {
                    errorHandler(error, reject)
                }
            });
        },
        approvalUndo(obj) {
            return new Promise(async (resolve, reject) => {
                try {
                    const resp = await axios.put(`/procure/send2wfCancel/${obj.pohdrkey}`);
                    resolve(resp);
                } catch (error) {
                    errorHandler(error, reject);
                }
            });
        },

    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.pohdrkey);
                url = `/procure/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    receivingdoc() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/receivingdoc");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`procure/${obj.pohdrkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxbypo(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['ponumber', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/trxbypo${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxvendor(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/trxvendor${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    trxvendorexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/procure/trxvendorexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `po_trx_vendor_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxbypoexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['ponumber', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/procure/trxbypoexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `po_trx_po_${obj.ponumber}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxvendorprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/trxvendorprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    trxbypoprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['ponumber', 'matauang', 'tgl2', 'alltrx'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/procure/trxbypoprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
    closevoid(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`procure/closevoid/${obj.pohdrkey}`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    statusUpdate(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`procure/statusupdate/${obj.pohdrkey}`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};